module.exports = __webpack_public_path__ + "static/media/dcard_edu.ca22ef0b.webp";